import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { corporateCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: number;
  field_banner_image: string;
  field_banner_sequence: number;
  title: string;
  field_banner_url_en: string;
  field_banner_url_ms: string;
  field_banner_url_zh: string;
  published: boolean;
  field_banner_created_at: string;
  field_banner_updated_at: string;
}

// edit api call
const fetchHomePageBannerDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await corporateCMSApi.get(`/api/get-homepage-banner/${id}`);
  return response.data[0];
};

const useHomePageBannerDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["homepageBannerDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchHomePageBannerDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useHomePageBannerDocumentDetails };
